import PaymentMethodDTO from "features/payments/dtos/PaymentMethodDTO";
import React from "react";
import PaymentMethodCard from "./PaymentMethodCard";
import { groupBy } from "features/shared/helpers/Arrays";
import { Currency } from "features/shared/enums/currency";
import ContactPersonDTO from "features/contractualAccounts/dtos/ContactPersonDTO";
import { useTranslation } from 'react-i18next';

interface Props {
  paymentMethods: PaymentMethodDTO[];
  contactPerson?: ContactPersonDTO;
  enabledAdvanceInvoicing?: boolean;
}

const PaymentMethodList = ({ paymentMethods, contactPerson, enabledAdvanceInvoicing }: Props) => {
  //translations
  const tLabels = useTranslation("payments\\payments").t;

  // sub-renders
  const renderPaymentMethodsByCurrency = () => {
    let groups = groupBy(paymentMethods, "currency");
    let result: JSX.Element[] = [];

    if (Object.keys(groups).length > 1) {
      let heading = <h4 className="my-3 text-muted">{tLabels("paymentMethodList.paymentMethodList")}</h4>;
      result.push(heading);
    }

    for (const [key, value] of Object.entries(groups)) {
      let elem = (
        <PaymentMethodCard
          paymentMethods={value}
          currency={key as Currency}
          contactPerson={contactPerson}
          enabledAdvanceInvoicing={enabledAdvanceInvoicing}
        />
      );
      result.push(elem);
    }

    return result;
  };

  // render
  return <>{renderPaymentMethodsByCurrency()}</>;
};

export default PaymentMethodList;
